!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? r(exports, require("react"), require("@material-ui/core")) : "function" == typeof define && define.amd ? define(["exports", "react", "@material-ui/core"], r) : r((e = e || self).popper = {}, e.React, e.core);
}(this, function (e, r, t) {
  "use strict";

  var o = "default" in r ? r.default : r;
  e.ArrowPopper = function (e) {
    var n = e.children,
        a = e.open,
        i = e.anchorElement,
        d = e.close,
        m = e.placement,
        l = e.color,
        p = e.arrowSize,
        s = e.borderStyle,
        c = e.disableClickAway,
        f = r.useState(),
        u = f[0],
        b = f[1],
        h = t.createMuiTheme(),
        w = function (e, r, o) {
      return t.makeStyles(function (n) {
        var a = "hint" === e ? "#2196f3" : void 0 !== e ? n.palette[e].main : "#ffffff",
            i = a ? n.palette.getContrastText(a) : "#242424",
            d = "square" === o ? 0 : "round" === o ? 200 : void 0,
            m = "small" === r ? 9 : "medium" === r ? 12 : 16;
        return t.createStyles({
          arrow: {
            position: "absolute",
            fontSize: m,
            width: "3em",
            height: "3em"
          },
          popper: {
            zIndex: 100,
            '&[x-placement*="top"] $arrow': {
              bottom: 0,
              width: 0,
              height: 0,
              borderLeft: "1em solid transparent",
              borderRight: "1em solid transparent",
              borderTop: "1em solid " + a,
              marginBottom: "-0.9em",
              "&::before": {
                borderWidth: " 1em 1em 0 1em",
                borderColor: "white transparent transparent transparent"
              }
            },
            '&[x-placement*="bottom"] $arrow': {
              width: 0,
              height: 0,
              borderLeft: "1em solid transparent",
              borderRight: "1em solid transparent",
              borderBottom: "1em solid " + a,
              marginTop: "-0.9em",
              "&::before": {
                borderWidth: "0 1em 1em 1em",
                borderColor: "transparent transparent white transparent"
              }
            },
            '&[x-placement*="right"] $arrow': {
              left: 0,
              width: 0,
              height: 0,
              borderTop: " 1em solid transparent",
              borderBottom: "1em solid transparent",
              borderRight: "1em solid " + a,
              marginLeft: "-0.9em",
              "&::before": {
                borderWidth: "1em 1em 1em 0",
                borderColor: "transparent white transparent transparent"
              }
            },
            '&[x-placement*="left"] $arrow': {
              right: 0,
              width: 0,
              height: 0,
              borderTop: "1em solid transparent",
              borderBottom: "1em solid transparent",
              borderLeft: "1em solid " + a,
              marginRight: "-0.9em",
              "&::before": {
                borderWidth: "1em 0 1em 1em",
                borderColor: "transparent transparent transparent white"
              }
            }
          },
          paper: {
            paddingTop: 8,
            paddingLeft: 12,
            paddingBottom: 8,
            paddingRight: 12,
            color: i,
            backgroundColor: a,
            borderRadius: d
          }
        });
      })();
    }(l, p || "medium", s || "normal");

    return i ? o.createElement(t.Popper, {
      className: w.popper,
      style: {
        zIndex: h.zIndex.modal + 1
      },
      open: a,
      anchorEl: i,
      placement: m,
      modifiers: {
        arrow: {
          enabled: !0,
          element: u
        },
        preventOverflow: {
          enabled: !0
        },
        flip: {
          enabled: !0
        }
      }
    }, o.createElement(t.Grow, {
      appear: !0,
      in: !0,
      timeout: 215
    }, o.createElement(t.Box, null, o.createElement("span", {
      className: w.arrow,
      ref: function ref(e) {
        return b(e);
      }
    }), o.createElement(t.ClickAwayListener, {
      mouseEvent: "onMouseDown",
      onClickAway: c ? function () {} : function () {
        return d();
      }
    }, o.createElement(t.Paper, {
      elevation: 12,
      className: w.paper
    }, n))))) : null;
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});